// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import styled from "styled-components";

import { Card, SlateCopy } from "~@jii/common-ui";
import {
  defaultComponents,
  SentenceDatesComponents,
} from "~@jii/sentence-dates";
import { useUsMaTranslations } from "~@jii/translation";

import { DateInfo } from "../Homepage/DatesSection/DateInfo";

const ParoleCard = styled(Card)`
  margin: 0;
`;

export const CardsWrapperOverride: SentenceDatesComponents["CardsWrapper"] = ({
  children,
  hidden,
  ...props
}) => {
  const { t } = useUsMaTranslations();

  return (
    <defaultComponents.CardsWrapper {...props}>
      {children}
      {!hidden && (
        <ParoleCard>
          <DateInfo label={t(($) => $.home.dates.parole.label)} muted />
          <SlateCopy>{t(($) => $.home.dates.parole.summary)}</SlateCopy>
        </ParoleCard>
      )}
    </defaultComponents.CardsWrapper>
  );
};
